var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#040810",
    className: "hover"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 25l6-6m-4-3l.463-.536a5 5 0 117.071 7.072L28 23m-5 5l-.397.534a5.068 5.068 0 01-7.127 0 4.97 4.97 0 010-7.07L16 21",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
export default SvgLinkIconDark;